import React, { useState, useEffect } from "react"

import { GlobalStyles } from "~/styles"
import { Header, Banner, Plans, About, Footer, Modal, SEO } from "~/components"

function Home() {
  const [modal, setModal] = useState(false)

  useEffect(() => {
    const dataLayer = window.dataLayer || []

    dataLayer.push({
      event: "step_change",
      pg_title: "home",
    })

    window.customData = {
      page: {
        name: "SOS Itaú Home",
      },
      site: {
        portal: "sos itau",
        versao: "1.0",
        brand: "Itaú",
        user: {
          numero: "",
          logged: "false",
        },
      },
    }
  }, [])

  function toggleModal() {
    setModal(open => !open)
  }

  return (
    <>
      <GlobalStyles />
      <SEO title="Início" />
      <Modal open={modal} close={toggleModal} />
      <Header />
      <main>
        <Banner />
        <Plans openModal={toggleModal} />
        <About />
      </main>
      <Footer />
    </>
  )
}

export default Home
